import React, { FC, useState, useMemo, useEffect } from 'react'

import CustomPopup from '../../UI/Popup'
import CustomButton from '../../UI/Buttons/CustomButton'
import Checkbox from '../../UI/Inputs/Checkbox'
import SocialToggler from '../../ToggleSocials'
import Preloader from '../../Preloader'

import { selectSocialMediaDataBySocialName } from '../../../selectors/ProjectSelector'

import { useDispatch, useSelector } from '../../../store'
import {
  closeDuplicateModalAction,
  addSelectedSocialToPost,
  removeSelectedSocialFromPost,
  resetDuplicateStateAction
} from '../../../store/modal/duplicatePost/slice'
import { getAllowedSocialsToDuplicatePostThunk, getAllowedToDuplicatePostThunk } from '../../../store/modal/duplicatePost/thunks'
import { SOCIAL_NETWORK } from '../../../models/post'

import './ModalDuplicatePost.scss'
import { openSchedulePostModal } from '../../../store/application/slice'
import { SCHEDULE_ACTION_TYPES } from '../../../store/application/types'

const ModalDuplicatePost: FC<any> = () => {
  const dispatch = useDispatch()

  const {
    postsForDuplicate,
    isDuplicateModalOpen,
    allowedSocials,
    connectedNetworks,
    socialDetails,
    isGettingAllowedSocials
  } = useSelector((state) => ({
    postsForDuplicate: state.duplicateModal.postForDuplicate,
    allowedSocials: state.duplicateModal.allowedSocials,
    isGettingAllowedSocials: state.duplicateModal.isGettingAllowedSocials,
    isDuplicateModalOpen: state.duplicateModal.isDuplicateModalOpen,
    project: state.project.currentProject,
    connectedNetworks: state.project.availableSocialNetworks,
    socialDetails: selectSocialMediaDataBySocialName(state)
  }))
  const [activeSocial, setActiveSocial] = useState<SOCIAL_NETWORK>(SOCIAL_NETWORK.FACEBOOK_SOCIAL)

  const filteredAllowedSocials = useMemo(
    () => allowedSocials.filter((social) => connectedNetworks.includes(social)),
    [connectedNetworks, allowedSocials]
  )

  const close = () => {
    dispatch(resetDuplicateStateAction())
    dispatch(closeDuplicateModalAction())
  }

  const rescheduleNewPost = () => {
    dispatch(closeDuplicateModalAction())
    dispatch(openSchedulePostModal(SCHEDULE_ACTION_TYPES.SCHEDULE_DUPLICATE))
  }

  useEffect(() => {
    const getAllowedSocials = async () => {
      if (!!postsForDuplicate.post_social_id) {
        await dispatch(getAllowedSocialsToDuplicatePostThunk(postsForDuplicate.post_social_id))
      }

      if( !!postsForDuplicate.post_id){
        await dispatch(getAllowedToDuplicatePostThunk(postsForDuplicate.post_id))
      }
    }
    if (!!postsForDuplicate.post_social_id || !!postsForDuplicate.post_id) {
      getAllowedSocials()
    }
  }, [postsForDuplicate.post_social_id,postsForDuplicate.post_id])

  const setAccountToPost = (checked: boolean, social: SOCIAL_NETWORK) => {
    checked
      ? dispatch(addSelectedSocialToPost(social))
      : dispatch(removeSelectedSocialFromPost(social))
  }

  const isDisabled = !postsForDuplicate?.social_networks.length

  const { post_social_id: postSocialId, social_networks: socialNetworks } = postsForDuplicate
  return (
    <CustomPopup
      open={isDuplicateModalOpen}
      buttonClose={close}
      closeOnDocumentClick={false}
      className='duplicate-post'
    >
      <div className='duplicate-post__wrapper'>
        <div className='duplicate-post__header'>Duplicate the content</div>
        <div className='duplicate-post__tooltip'>
          Select profile(s)
          <br></br>
        </div>
        <div className='duplicate-post__content'>
          {!isGettingAllowedSocials ? (
            <SocialToggler
              isChecked={(social) =>
                socialNetworks.some((selectedSocial) => selectedSocial === social)
              }
              key={postSocialId}
              socials={filteredAllowedSocials}
              {...{ activeSocial, setActiveSocial }}
            >
              {filteredAllowedSocials.map((social: SOCIAL_NETWORK, index: number) => {
                if (activeSocial === social) {
                  return (
                    <div key={`connected-account-${index}`} className='duplicate-post__accounts'>
                      <div className='account'>
                        <div className='account__user-info'>
                          {socialDetails[social].logo.original ? (
                            <img
                              className='account__user-info__icon'
                              alt='avatar'
                              src={socialDetails[social].logo.original}
                            />
                          ) : (
                            socialDetails[social].logo.default
                          )}
                          <div className='account__user-info__name'>
                            {socialDetails[social]!.name}
                          </div>
                        </div>
                        <Checkbox
                          type='checkbox'
                          checked={socialNetworks.some(
                            (socialFromPost) => socialFromPost === social
                          )}
                          onChange={({
                            target: { checked }
                          }: React.ChangeEvent<HTMLInputElement>) =>
                            setAccountToPost(checked, activeSocial)
                          }
                        />
                      </div>
                    </div>
                  )
                }
              })}
            </SocialToggler>
          ) : (
            <Preloader />
          )}
        </div>
        <div className='duplicate-post__actions'>
          <CustomButton onClick={close} button='secondary'>
            No
          </CustomButton>
          <CustomButton disabled={isDisabled} button='primary' onClick={rescheduleNewPost}>
            Yes
          </CustomButton>
        </div>
      </div>
    </CustomPopup>
  )
}

export default ModalDuplicatePost
